module.exports = __webpack_public_path__ + "assets/img/63ab50aa3c12d028e87d256c01251ba3.svg";